(() => {
  const SHEEN_TARGETS = '.q-btn, .qft__submit, .product-form__submit, .cart__checkout-button, .button--primary';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function addSheen(root) {
    root.querySelectorAll(SHEEN_TARGETS).forEach((el) => {
      if (el.tagName === 'INPUT' || el.querySelector(':scope > .q-sheen')) return;
      el.classList.add('q-sheen-host');
      const sheen = document.createElement('span');
      sheen.className = 'q-sheen';
      sheen.setAttribute('aria-hidden', 'true');
      el.appendChild(sheen);
    });
  }

  addSheen(document);
  // Cart drawer and section re-renders swap markup in, so watch for new buttons.
  new MutationObserver((mutations) => {
    mutations.forEach((m) => m.addedNodes.forEach((n) => n.nodeType === 1 && addSheen(n)));
  }).observe(document.body, { childList: true, subtree: true });

  // `click` (not pointerdown) so scrolling or swiping on phones doesn't trigger it.
  document.addEventListener('click', (event) => {
    if (reduceMotion.matches || event.detail === 0) return;
    const ripple = document.createElement('span');
    ripple.className = 'q-ripple';
    ripple.style.left = `${event.clientX}px`;
    ripple.style.top = `${event.clientY}px`;
    ripple.addEventListener('animationend', () => ripple.remove());
    document.body.appendChild(ripple);

    // Mirror buttons pop and throw a ring.
    const btn = event.target.closest('.q-btn');
    if (!btn) return;
    btn.classList.remove('q-btn--pop');
    void btn.offsetWidth;
    btn.classList.add('q-btn--pop');
    const burst = document.createElement('span');
    burst.className = 'q-btn-burst';
    burst.setAttribute('aria-hidden', 'true');
    burst.addEventListener('animationend', () => burst.remove());
    btn.appendChild(burst);
  }, true);
})();
